module.exports = __webpack_public_path__ + "img/ajans-press-courier-ad-02.15b5e620.jpg";